import React from "react";
import { Box, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { PageLayout } from "@APP/components";

const useStyles = makeStyles(() => ({
  underline: {
    textDecoration: "underline",
  },
  list: {
    paddingLeft: 30,
  },
  subList: {
    paddingLeft: 40,
  },
}));

const PrivacyNoticeScreen = () => {
  const styles = useStyles();

  return (
    <PageLayout>
      <Box maxWidth={980} alignSelf="center" id="privacyPolicyBox">
        <Typography variant="h5" align="center" className={styles.underline}>
          Privacy Notice
        </Typography>
        <br />
        <Typography variant="body2">
          This Privacy Notice tells you how your personal data is used and protected when you access
          the Go Get Paid Mobile App and Web Services (together "Go Get Paid") and tells you about
          your privacy rights and how the law protects you.
        </Typography>
        <br />

        <Typography className={styles.underline}>
          <b>Who We Are</b>
        </Typography>
        <br />
        <Typography variant="body2">
          In this privacy notice when we say <b>"BankiFi"</b> or <b>"we"</b> or <b>"us"</b> or{" "}
          <b>"our"</b> we mean BankiFi Technology Limited.
        </Typography>
        <br />
        <Typography variant="body2">
          Company number: 10696778
          <br />
          Address: Centurion House, 129 Deansgate, Manchester, M3 3WR
          <br />
          Email:{" "}
          <u>
            <a href="mailto:support@gogetpaid.co.uk">support@gogetpaid.co.uk</a>
          </u>
        </Typography>
        <br />
        <Typography variant="body2">
          BankiFi is the data controller responsible for your personal data.
        </Typography>
        <br />
        <Typography variant="body2">
          When we say <b>"you"</b> or <b>"your"</b>, we mean the person whose personal data we
          process as a result of that person or another person's use of the Go Get Paid Services.
        </Typography>
        <br />

        {/* ── PAYEE ── */}
        <Typography className={styles.underline}>
          <b>Payee</b>
        </Typography>
        <br />
        <Typography variant="body2">
          As a Payee, we only collect and process personal information that is necessary to provide
          Our Service to you.
        </Typography>
        <br />

        <Typography>
          <b>Information We Collect</b>
        </Typography>
        <br />
        <Typography variant="body2">
          When you register, we store the following details:
          <ul className={styles.list}>
            <li>Your company details (if applicable)</li>
            <li>Your name</li>
            <li>Your email address</li>
            <li>Your mobile phone number</li>
          </ul>
        </Typography>
        <br />
        <Typography variant="body2">
          This information is used to enable us to send Requests for Payment on your behalf.
        </Typography>
        <br />
        <Typography variant="body2">
          If you choose to send Requests for Payment to others (Payers), we will also collect and
          store the Payer's:
          <ul className={styles.list}>
            <li>Name</li>
            <li>Email address</li>
            <li>Mobile phone number</li>
          </ul>
        </Typography>
        <br />
        <Typography variant="body2">
          This information is used solely for the purpose of sending payment requests.
        </Typography>
        <br />

        <Typography>
          <b>How We Protect Your Information</b>
        </Typography>
        <br />
        <Typography variant="body2">
          We take our responsibility to protect your personal information seriously and process all
          data in line with UK GDPR requirements.
        </Typography>
        <br />
        <Typography variant="body2">
          We are ISO27001 and SOC 2 accredited, meaning we follow strict policies, procedures, and
          security controls to protect all information we hold.
        </Typography>
        <br />

        <Typography>
          <b>Your Data Protection Rights</b>
        </Typography>
        <br />
        <Typography variant="body2">
          Under data protection law, you have the right to request access to the personal
          information we hold about you (commonly known as a Data Subject Access Request). This
          allows you to:
          <ul className={styles.list}>
            <li>Receive a copy of your personal data</li>
            <li>Check that we are processing your data lawfully</li>
          </ul>
        </Typography>
        <br />
        <Typography variant="body2">
          You also have the right to erasure, meaning you can ask us to delete your personal
          information where permitted by law.
        </Typography>
        <br />
        <Typography variant="body2">
          To exercise these rights or if you have any questions about how your data is stored and
          protected, please contact us at{" "}
          <u>
            <a href="mailto:erasure@gogetpaid.co.uk">erasure@gogetpaid.co.uk</a>
          </u>
          .
        </Typography>
        <br />

        <Typography>
          <b>Open Banking Access</b>
        </Typography>
        <br />
        <Typography variant="body2">
          To use Our Service, you provide consent through Open Banking for us to view your bank
          transactions. This allows us to confirm that payments have been received into your bank
          account.
        </Typography>
        <br />
        <Typography variant="body2">
          This access is granted via your bank's internet or mobile banking service. We:
          <ul className={styles.list}>
            <li>Do not have access to your sort code or account number</li>
            <li>Do not have access to any additional account information</li>
          </ul>
        </Typography>
        <br />
        <Typography variant="body2">
          Your banking details remain private and secure at all times.
        </Typography>
        <br />
        <Typography variant="body2">
          If we wish to use this information for additional services in the future, we will always
          ask for your explicit consent and clearly explain what information is being used and why.
        </Typography>
        <br />

        <Typography>
          <b>Cookies and App Analytics</b>
        </Typography>
        <br />
        <Typography variant="body2">
          We use cookies to support the secure and reliable operation of the Go Get Paid app.
        </Typography>
        <br />
        <Typography variant="body2">
          We use cookies to understand how visitors interact with our content.
        </Typography>
        <br />
        <Typography variant="body2">
          <b>Why We Use Cookies</b>
          <ul className={styles.list}>
            <li>Session tracking and troubleshooting</li>
            <li>
              Performance and usage analysis, including capturing app interactions through 3rd–
              party enabled widgets to help us identify and resolve issues
            </li>
          </ul>
        </Typography>
        <br />
        <Typography variant="body2">
          <b>Cookie Consent</b>
          <br />
          Before enabling session recording and diagnostic features, we request your explicit cookie
          consent by approving the pop up when you login.
          <ul className={styles.list}>
            <li>If you have already provided consent, you will not see the message again</li>
            <li>
              If consent has not yet been provided, a cookie consent message will appear within the
              app requesting your approval
            </li>
            <li>If it is rejected, Go Get Paid will not ask again for 7 days</li>
          </ul>
        </Typography>
        <br />
        <Typography variant="body2">
          Once consent is granted:
          <ul className={styles.list}>
            <li>
              App sessions may be recorded and analysed for troubleshooting and service improvement
            </li>
            <li>No session recordings will take place without prior consent</li>
            <li>
              Your consent choice will be saved as a cookie on your device to avoid repeated prompts
            </li>
          </ul>
        </Typography>
        <br />

        <Typography>
          <b>Managing Your Cookie Preferences</b>
        </Typography>
        <br />
        <Typography variant="body2">
          You can manage or withdraw your cookie consent by clearing cookies from your browser.
        </Typography>
        <br />
        <Typography variant="body2">
          Please note that disabling cookies may limit some troubleshooting and diagnostic features,
          but it will not affect core payment functionality.
        </Typography>
        <br />

        <Typography>
          <b>Data Sharing</b>
        </Typography>
        <br />
        <Typography variant="body2">
          We may share your data with The Co-operative Bank Plc for the purpose of improving the
          quality, availability, and access to products and services.
        </Typography>
        <br />

        {/* ── PAYER ── */}
        <Typography className={styles.underline}>
          <b>Payer Privacy Information</b>
        </Typography>
        <br />
        <Typography variant="body2">
          As a Payer, we do not actively collect personal information from you directly through Our
          Service.
        </Typography>
        <br />

        <Typography>
          <b>Information We Process</b>
        </Typography>
        <br />
        <Typography variant="body2">
          When a Payee sends you a Request for Payment, they provide us with limited personal
          information about you, which may include:
          <ul className={styles.list}>
            <li>Your name</li>
            <li>Your email address</li>
            <li>Your mobile phone number</li>
          </ul>
        </Typography>
        <br />
        <Typography variant="body2">
          We store and process this information solely for the purpose of:
          <ul className={styles.list}>
            <li>Sending the Request for Payment to you</li>
            <li>Enabling you to complete the payment</li>
          </ul>
        </Typography>
        <br />
        <Typography variant="body2">
          We do not use this information for any other purpose.
        </Typography>
        <br />

        <Typography>
          <b>How We Protect Your Information</b>
        </Typography>
        <br />
        <Typography variant="body2">
          We take our responsibility to protect personal data seriously and process all information
          in line with UK GDPR requirements.
        </Typography>
        <br />
        <Typography variant="body2">
          We are ISO27001 and SOC 2 accredited, which means we follow strict policies, procedures,
          and security controls to protect all information we hold.
        </Typography>
        <br />

        <Typography>
          <b>Your Data Protection Rights</b>
        </Typography>
        <br />
        <Typography variant="body2">
          Under data protection law, you have the right to request access to the personal
          information we hold about you (commonly known as a Data Subject Access Request). This
          enables you to:
          <ul className={styles.list}>
            <li>Receive a copy of your personal data</li>
            <li>Check that we are processing your information lawfully</li>
          </ul>
        </Typography>
        <br />
        <Typography variant="body2">
          You also have the right to erasure, meaning you can request that your personal information
          is deleted where permitted by law.
        </Typography>
        <br />
        <Typography variant="body2">
          If you would like us to remove your information or have any questions about how your data
          is stored and protected, please contact{" "}
          <u>
            <a href="mailto:support@gogetpaid.co.uk">support@gogetpaid.co.uk</a>
          </u>
          .
        </Typography>
        <br />

        <Typography>
          <b>Payments and Banking Information</b>
        </Typography>
        <br />
        <Typography variant="body2">
          When you make a payment using Our Service, this is completed through your own bank's
          internet or mobile banking service.
        </Typography>
        <br />
        <Typography variant="body2">
          Go Get Paid:
          <ul className={styles.list}>
            <li>Does not access any information within your banking service</li>
            <li>Does not see your sort code, account number, or other account details</li>
          </ul>
        </Typography>
        <br />
        <Typography variant="body2">
          These details remain private to you at all times when using Our Service.
        </Typography>
        <br />
      </Box>
    </PageLayout>
  );
};

export default PrivacyNoticeScreen;
